module.exports = __webpack_public_path__ + "static/media/notifications-activer.3658f470.png";